/* eslint-disable */
export default {
  _asapbold: 'asapbold',
  _asapmedium: 'asapmedium',
}